<template>
  <div>
    <div class="form-group d-flex flex-column">
      <label class="custom-label">{{ $t('ct-video') }}</label>
      <div class="form">
        <button class="btn btn-outline-info" @click="getImages">{{ $t('ct-change-video') }}</button>
        <font-awesome-icon
          v-show="canRemove"
          :icon="['far', 'trash-alt']"
          class="font-awesome-icon danger"
          v-on:click="removeImage"
        />
      </div>
    </div>
    <div class="form-group">
      <label class="custom-label">{{ $t('ct-resource-external-video') }}</label>
      <div class="input-group">
        <input type="text" class="custom-input form-control " v-model="valueInput"
               placeholder="https://somevideourl.com.br">
        <div class="input-group-append">
          <button class="btn btn-primary btn-small video-background__custom-button" type="button" @click="applyExternalVideo">{{ $t('ct-resource-apply') }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-group hidden-resource" v-if="value != ''">
      <!--        <label class="custom-label" style="width: 100%">{{this.type}}</label>-->
      <div class="form">
        <div class="radio" ref="origin">
          <label>
            <input type="checkbox" name="videoInternal" v-model="videoInternal" @change="changeValue"
                   @keyup="changeValue">
            {{$t('ct-bg-config-video-internal')}}
          </label>
          <label>
            <input type="checkbox" name="videoautoplay" v-model="autoplay" @change="changeValue"
                   @keyup="changeValue">
            {{$t('ct-bg-config-autoplay')}}
          </label>
          <label>
            <input type="checkbox" name="videomuted" v-model="muted" @change="changeValue"
                   @keyup="changeValue">
            {{$t('ct-bg-config-muted')}}
          </label>
          <label>
            <input type="checkbox" name="videoloop" v-model="loop" @change="changeValue"
                   @keyup="changeValue">
            {{$t('ct-bg-config-loop')}}
          </label>
        </div>
      </div>
    </div>
		<div class="ct-alert-container">
			<div class="ct-alert-content">
				{{ $t('ct-video-browsers-warning') }}
			</div>
		</div>

  </div>
</template>

<script>
	import {getImages} from '../../../js/services/editor/externalImage';
	import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
	import FileUpload from 'v-file-upload';
	import FileManager from './../../general/FilesManager/FileManager'

	export default {
		name: 'VideoComponent',
		components: {
			SweetModal,
			SweetModalTab,
			FileUpload,
			FileManager
		},
		data() {
			return {
				images: [],
				directories: [],
				element: null,
				imageSelected: null,
				value: '',
				valueInput: '',
				canRemove: false,
				canExternal: false,

				videoInternal: false,
				autoplay: false,
				muted: false,
				loop: false,

				labelDesc: 'opa',
				callback: null,
				headers: {
					authorization: 'Bearer ' + localStorage.getItem('token')
				}
			};
		},
		methods: {
			applyExternalVideo() {

				let extension = this.valueInput.split('.').pop().toLowerCase();

				if (typeof extension != 'undefined') {

					if (extension != 'mp4' && extension != 'webm' && extension != 'ogg') {
						this.$snotify.warning(this.$t('ct-invalid-format'));
						this.valueInput = '';

					} else {
						this.value = this.valueInput;
						this.changeValue();
					}
				}
			},

			removeImage() {
				this.value = '';
				this.changeValue();
			},

			save(image) {
				this.imageSelected = image;

				if (typeof this.callback === 'function') {
					this.value = this.imageSelected;
					this.changeValue();
				} else {
					this.element.internal_config.src = this.imageSelected;
				}
				this.close();
			},

			close() {
				let values = {
					action: 'close',
					type: 'Videos',
					save: this.save,
					close: this.close
				};
				this.$root.$emit('fileMananger', values);
			},

			selectImage(image) {
				let elements = document.getElementsByClassName('focused');
				[].forEach.call(elements, function (el) {
					el.classList.remove('focused');
				});

				this.imageSelected = image;
				document.getElementById(image.id).classList.add('focused');
			},

			getImages() {

				let values = {
					action: 'open',
					type: 'Videos',
					save: this.save,
					close: this.close
				};
				this.$root.$emit('fileMananger', values);
			},
			changeTab(id) {
				var navtabActive = this.$refs.modalImages.querySelectorAll(
					'.nav-link.active, .tab-pane.active'
				);
				Object.keys(navtabActive).forEach(index => {
					navtabActive[index].classList.remove('active');
					navtabActive[index].classList.remove('show');
				});

				if (this.$refs['nav-tab-' + id].classList) {
					this.$refs['nav-tab-' + id].classList.add('active');
					this.$refs['nav-tab-' + id].classList.add('show');
				}

				if (this.$refs['nav-' + id].classList) {
					this.$refs['nav-' + id].classList.add('active');
				}
			},
			changeValue() {
				let obj = {};
				obj.video = this.value ;
				obj.videoInternal = this.videoInternal ;
				obj.autoplay = this.autoplay ;
				obj.muted = this.muted ;
				obj.loop = this.loop ;
				this.callback(obj);
			},
			setValues(obj) {


				this.value = obj.defaultValue;
				this.videoInternal = obj.defaultValueInternal;
				this.autoplay = obj.defaultValueAutoplay;
				this.muted = obj.defaultValueMuted;
				this.loop = obj.defaultValueLoop;
				this.canRemove = obj.canRemove;

				this.callback = obj.callback;

			}
		}
	};
</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  .image-item {
    width: 140px;
    height: 70px;
    display: inline-block;
    cursor: pointer;
    text-align: center;
  }

  .image-item.focused {
    outline: 2px solid blue;
  }

  .image-item img {
    width: 100px;
    height: 50px;
  }

  .image-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

  .radio {
    display: inline-grid;
    margin-left: 5px;
    width: 100%;
	}

	.video-background__custom-button {
		background-color: #01d4b9;
		border-color: darken(#01d4b9, 1%);
	}
</style>

<style lang="scss">
  /*.sweet-modal {*/

  /*  .sweet-content {*/
  /*    max-height: 70vh !important;*/
  /*    overflow: auto;*/
  /*    text-align: left;*/
  /*  }*/

  /*  .btn {*/
  /*    cursor: pointer;*/
  /*    margin-left: 5px;*/
  /*  }*/
  /*}*/

  /*.upload-area {*/
  /*  text-align: right;*/
  /*  padding-bottom: 20px;*/
  /*  height: 70px;*/

  /*  .file-upload .input-wrapper {*/
  /*    height: 50px;*/
  /*    width: 15%;*/
  /*    float: right;*/
  /*  }*/

  /*  .file-upload-icon {*/
  /*    display: none !important;*/
  /*  }*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/editor/resource_components/VideoBackground.vue